import { useSelector } from 'react-redux';

import { RootState } from '../ducks/store';
import { hasTeamManagerRole } from '../utils';

interface IUseGetTeamCourses {
  getTeamsCourseIds: (teamIds: string[]) => string[];
}

export const useGetTeamCourses = (): IUseGetTeamCourses => {
  // ===========================================================================
  // Redux
  // ===========================================================================

  const teams = useSelector((state: RootState) => {
    const user = state.auth.authenticatedUser;
    const isTeamManager = hasTeamManagerRole(user);

    return isTeamManager ? user?.teams : state.teams.list;
  });

  // ===========================================================================
  // Functions
  // ===========================================================================

  /**
   * Get course ids associated with teams (ids)
   * @param teamIds - Team ids
   * @returns Course ids
   */
  const getTeamsCourseIds = (teamIds: string[]) => {
    if (!teams?.length) {
      return [];
    }

    const selectedTeams = teamIds.map((teamId: string) =>
      teams.find((team: ITeam) => team._id === teamId),
    ) as ITeam[]; // Get newly selected teams objects

    const teamCourseIds = selectedTeams.reduce((acc: string[], team: ITeam) => {
      const courses = (team?.courses || []) as string[];
      return [...acc, ...courses];
    }, []); // Get courses associated with newly selected teams

    return Array.from(new Set(teamCourseIds));
  };

  return {
    getTeamsCourseIds,
  };
};
